import { render, staticRenderFns } from "./OrderAnalytics.vue?vue&type=template&id=9c327122&scoped=true&"
import script from "./OrderAnalytics.vue?vue&type=script&lang=js&"
export * from "./OrderAnalytics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c327122",
  null
  
)

export default component.exports